import { STORAGE_KEYS } from '@/constants/storage-keys.constants';
import type { AppLocale } from '@/types/common.types';

function isAppLocale(value: string | null): value is AppLocale {
  return value === 'en' || value === 'de';
}

export const localeStorage = {
  get(): AppLocale | null {
    const stored = window.localStorage.getItem(STORAGE_KEYS.LOCALE);
    return isAppLocale(stored) ? stored : null;
  },
  set(locale: AppLocale): void {
    window.localStorage.setItem(STORAGE_KEYS.LOCALE, locale);
  },
};
